import { render } from "./internetBanking.vue?vue&type=template&id=19b818bc&bindings={\"navigate\":\"props\"}"
import script from "./internetBanking.vue?vue&type=script&lang=js"
export * from "./internetBanking.vue?vue&type=script&lang=js"
script.render = render
/* custom blocks */
import block0 from "./internetBanking.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(script)


export default script